const TOKEN_KEY = "token";
const USER_INFO_KEY = "userInfo";

/** 无需携带 token 的接口路径 */
const AUTH_SKIP_PATHS = ["/auth/login", "/auth/register"];

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_INFO_KEY);
}

/** 从登录接口响应中解析用户信息（data.user） */
export function extractUserFromResponse(res) {
  const data = res && res.data;
  if (!data || typeof data !== "object") {
    return { realName: "", phone: "", expireHours: null };
  }
  const user = data.user || {};
  return {
    realName: user.realName || user.real_name || "",
    phone: user.phone || "",
    expireHours: data.expireHours != null ? data.expireHours : null,
  };
}

export function setUserInfo(user) {
  localStorage.setItem(
    USER_INFO_KEY,
    JSON.stringify({
      realName: user.realName || "",
      phone: user.phone || "",
      expireHours: user.expireHours != null ? user.expireHours : null,
      loginAt: Date.now(),
    })
  );
}

export function getUserInfo() {
  try {
    return JSON.parse(localStorage.getItem(USER_INFO_KEY) || "{}");
  } catch (e) {
    return {};
  }
}

/** 顶部展示名：realName 优先，否则 phone */
export function getDisplayName() {
  const { realName, phone } = getUserInfo();
  const name = String(realName || "").trim();
  if (name) return name;
  const mobile = String(phone || "").trim();
  if (mobile) return mobile;
  return "管理员";
}

export function isLoggedIn() {
  return !!getToken();
}

export function shouldAttachToken(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return !AUTH_SKIP_PATHS.some(
    (skip) => normalized === skip || normalized.startsWith(`${skip}?`)
  );
}

/** 从登录接口响应中解析 token */
export function extractTokenFromResponse(res) {
  if (!res) return "";
  const data = res.data;
  if (typeof data === "string" && data) return data;
  if (data && typeof data === "object") {
    return (
      data.token ||
      data.accessToken ||
      data.access_token ||
      data.authorization ||
      ""
    );
  }
  return res.token || res.accessToken || res.access_token || "";
}
